// Herinneringen op het bord (0021): de oproep "Yakub, klaarmaken voor trainen!" en de hint in de
// Nu/Straks-strook. Apart bestand zodat nl.ts klein blijft; de sleutels staan in `m.reminders.*`.
// Je-vorm, kort, icoon eerst (docs/DESIGN.md §2).
export const kioskRemindersNl = {
    /** De ene grote knop per kind. */
    ok: 'Oké!',
    /** Rustig, buiten het thema Kinderen. */
    okCalm: 'Oké',
    /** Voorgelezen (nl-NL): één keer, na 60 s nog één keer als niemand tikte. */
    speak: '{names}, {title}!',
    /** Kleine contextregel onder de titel. */
    context: '{title} om {time}',
    /** Hint in de Nu/Straks-strook als een oproep binnen het uur komt. */
    hint: 'Straks: {title} · {time}',
    and: 'en',
    /** Schermlezer: de oproep als geheel. */
    dialog: 'Herinnering: {title}',
    /** Schermlezer: "Oké!" van één kind. */
    okFor: 'Oké, {name}',
    // 0031: de checklist naast de oproep (groot, plaatje eerst; afvinken blokkeert Oké! niet).
    checklist: 'Mee in de tas',
    /** Rustige hint: nog zoveel dingen zonder vinkje. */
    checklistLeft: 'nog {count}',
    checklistDone: 'Alles erin!',
    checklistDoneCalm: 'Alles is bij',
    /** Schermlezer per rij. */
    checklistItem: '{label}, {name}',
    checklistItemDone: '{label} zit erin',
    /** 0055: contextregel bij een taak die op zijn tijd wordt omgeroepen. */
    taskContext: 'Taak om {time}',
};
//# sourceMappingURL=reminders.nl.js.map